import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '../../../components/ui/alert-dialog'

/**
 * Restores archived config versions so pickers and intake endpoints can use
 * them again. When `intake` is set, the confirm also turns that intake on.
 */
export function UnarchiveConfigDialog({
  open,
  onOpenChange,
  name,
  versionCount,
  loading,
  error,
  onConfirm,
  intake
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  name: string
  versionCount: number
  loading: boolean
  error?: string
  onConfirm: () => void
  /** The intake endpoint this restore turns on. */
  intake?: { name: string; enabled: boolean }
}) {
  const versions = `${versionCount} archived version${versionCount === 1 ? '' : 's'}`
  const description = intake
    ? intake.enabled
      ? `This restores ${versions} of ${name}. ${intake.name} is on, so new files start running.`
      : `This restores ${versions} of ${name} and turns ${intake.name} on. New files start running.`
    : `This restores ${versions} of ${name}. They show in pickers again, and intake endpoints that point at them can start new runs.`

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {intake ? `Make ${intake.name} active?` : `Unarchive ${name}?`}
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {error ? (
          <p role="alert" className="text-sm text-st-down">
            {error}
          </p>
        ) : null}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={loading || versionCount < 1}
            onClick={(event) => {
              event.preventDefault()
              onConfirm()
            }}
          >
            {intake ? 'Make active' : 'Unarchive'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
